import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ComponentDataTable, DefaultModal, SimpleCenteredModal } from '../../components';
import columns from './FeeProcessColumns';
import { sendAlert } from '../../actions/utils';
import massiveActions from '../RemunerationProcesses/AdvancePayments/Datatables/massiveActions';
import { downloadFile } from '../../services/utils';
import {
  indexFeePaymentProcessesRequest,
  deleteFeePaymentProcessRequest,
  closeFeePaymentProcessRequest,
  massiveDestroyFeePaymentProcessRequest,
  exportFeePaymentProcessesRequest
} from '../../requests/feeProcesses';

const defaultModalState = {
  title: '',
  body: null,
  show: false
};

const FeeProcessDataTable = ({ moreData, setMoreData, customParams, setOnRequest, onRequest }) => {
  const [modalAction, setModalAction] = useState(() => null);
  const [modalBody, setModalBody] = useState('');
  const [modalItem, setModalItem] = useState({});
  const [amount, setAmount] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [simpleModalState, setSimpleModalState] = useState(defaultModalState);
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [feeProcesses, setFeeProcesses] = useState([]);
  const [selectedCount, setSelectedCount] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSelectedRows = item => {
    setSelectedRows(item.selectedRows);
    setSelectedCount(item.selectedCount);
  };

  const handleRequest = async params => {
    setOnRequest(true);
    setClearSelectedRows(false);
    indexFeePaymentProcessesRequest({
      dispatch,
      params: {
        ...customParams,
        ...params
      },
      successCallback: response => {
        setOnRequest(false);
        setFeeProcesses(response.data.data);
        setAmount(response?.data?.metadata?.amount);
      },
      callback: () => {
        setOnRequest(false);
        setClearSelectedRows(true);
      }
    });
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleSuccess = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
  };

  const removeFeeProcess = item => {
    setOnRequest(true);
    deleteFeePaymentProcessRequest(item.id, {
      dispatch,
      successCallback: () => handleSuccess('Proceso Eliminado Correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
      }
    });
  };

  const closeFeeProcess = item => {
    setOnRequest(true);
    closeFeePaymentProcessRequest(item.id, {
      dispatch,
      successCallback: () => handleSuccess('Proceso Cerrado Correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
      }
    });
  };

  const massiveDestroy = () => {
    const feeProcessIds = selectedRows.map(fee => fee.id);

    setOnRequest(true);
    setClearSelectedRows(false);
    massiveDestroyFeePaymentProcessRequest({
      dispatch,
      params: {
        ids: feeProcessIds
      },
      successCallback: () => handleSuccess('Procesos Eliminados Correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
        setClearSelectedRows(true);
        setMoreData(!moreData);
      }
    });
  };

  const handleFailureRequest = error => {
    dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
    setOnRequest(false);
  };

  const massiveExport = () => {
    const feeProcessIds = selectedRows.map(fee => fee.id);
    setOnRequest(true);
    exportFeePaymentProcessesRequest({
      dispatch,
      params: {
        filter_by_ids: feeProcessIds,
        ...customParams
      },
      successCallback: response => {
        setModalShow(false);
        downloadFile(response);
        setOnRequest(false);
      },
      failureCallback: handleFailureRequest
    });
  };

  const handleFeeProcessEdit = async item => {
    history.push({ pathname: `/fee_processes/${item.id}/edit`, state: { item, onlyShow: false } });
  };

  const handleButtonClick = (item, action) => {
    switch (action) {
      case 'show':
        history.push({ pathname: `/fee_processes/${item.id}/edit`, state: { item, onlyShow: true } });
        break;
      case 'edit':
        handleFeeProcessEdit(item);
        break;
      case 'destroy':
        setModalTitle('Eliminar Proceso de Honorarios');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas eliminar este mes de proceso?');
        setModalAction(() => removeFeeProcess);
        setModalItem(item);
        break;
      case 'close':
        setModalTitle('Cerrar Proceso de Honorarios');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas cerrar este mes de proceso?');
        setModalAction(() => closeFeeProcess);
        setModalItem(item);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Error: Action not found');
    }
  };

  const handleClick = action => {
    switch (action) {
      case 'massive_deactivate':
        setModalTitle('Eliminar Procesos de Honorarios');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas eliminar los procesos seleccionados?');
        setModalAction(() => massiveDestroy);
        break;
      case 'massive_export':
        setModalTitle('Descargar Procesos de Honorarios');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas descargar los procesos seleccionados?');
        setModalAction(() => massiveExport);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Error: Action not found');
    }
  };

  return (
    <>
      <ComponentDataTable
        onRequest={onRequest}
        resourceRequest={handleRequest}
        columns={columns(handleButtonClick)}
        data={feeProcesses}
        totalRows={amount}
        moreData={moreData}
        selectableRows
        selectedRowCount={selectedRows.selectedCount}
        clearSelectedRows={clearSelectedRows}
        onSelectedRowsChange={handleSelectedRows}
        withMassActions
        massActions={massiveActions(handleClick, true, !selectedCount)}
      />
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={() => handleModalClose}
        handleConfirm={() => modalAction(modalItem)}
        disabled={onRequest}
        variantBtnClose="outline-info"
        variantBtnSave="primary"
      />
      <SimpleCenteredModal
        title={simpleModalState.title}
        size="md"
        body={simpleModalState.body}
        show={simpleModalState.show}
        onHide={() => setSimpleModalState(state => ({ ...state, show: false }))}
      />
    </>
  );
};

export default FeeProcessDataTable;
